import { render } from "./ChartAplicationUserByRole.vue?vue&type=template&id=19e70254"
import script from "./ChartAplicationUserByRole.vue?vue&type=script&lang=js"
export * from "./ChartAplicationUserByRole.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])